import { type BaseErrorExtensions } from '@adornis/validation/errors/BaseError.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class RegistrationAuthorizationNeededError extends ExpectedError {
  static override _class = 'RegistrationAuthorizationNeededError';

  userID?: string;

  public constructor(userID: string, extensions: BaseErrorExtensions = {}) {
    super('RegistrationAuthorizationNeededError', {
      ...extensions,
      translationKey: 'REGISTRATION_AUTHORIZATION_NEEDED_ERROR',
      userID,
    });
    this.userID = userID;
  }

  static override createFromDetails(message: string, extensions: BaseErrorExtensions) {
    return new this(extensions.userID, extensions);
  }
}
